/* ============================================================
   HERZ DER KARTEN – cart-page.js  (/cart)
   Spiegelt den Cart-Drawer: Mutationen via Sections API (update.js mit
   sections:'main-cart' plus den Drawer-Sections, SECTIONS_SEITE) -> HTML-Swap statt
   manuellem Patchen. Server-autoritativ:
   ein Request pro Klick, UI aendert sich erst aus der Antwort (kein optimistisches
   Update). Item-Markup kommt aus snippets/cart-line-item.liquid; die Menge waehlt man
   per Auswahl 1–5 / «6+», ab 6 per Feld an derselben Stelle (Block «Mengenwahl»; die
   Implementierung teilt die Seite mit dem Drawer: window.cartMengenwahl in cart-drawer.js),
   entfernt wird ueber den Textknopf «Entfernen» der Zeile.
   Natives <form> bleibt No-JS-Fallback (JS faengt Submit ab).
   Dazu das Kassen-Dock (mobil): Sichtbarkeit + Body-Polster, bindDock() unten,
   der Warenkorbfueller (snippets/cart-filler.liquid, context 'page'):
   Plus-Klick (onFillerAdd), Maus-Drag und Kanten-Fades des Streifens (fuellerBinden),
   und das Cross-Selling (snippets/cart-cross-sell.liquid): ab 900 Raster-Init ueber
   brand-strip.js (bindCrossSell), unter 900
   der Fueller-Streifen mit Plus wie beim Fueller (fuellerBinden, onFillerAdd),
   das Bewertungs-Karussell der Zusammenfassung (snippets/cart-reviews.liquid,
   bindReviews), die Lagerzeile jeder Position (verfuegbarkeit, ab 900 sichtbar), die
   Kurzform «Sale» der Rabattzeile (Bindung rabattBinden, Messung window.cartRabattKurzform
   aus cart-drawer.js, alle Breiten),
   die Lieferzeile unter dem Seitentitel (lieferzeile, alle Breiten) und die Seiten-Flaeche
   des Mehr-Dialogs (#cart-mehr: «Weitere Warenkorbfueller» / «Weitere passende Produkte»
   mit Kaufknopf; Dialog = window.cartMehr in cart-drawer.js, Block «Mehr-Dialog» unten).
   ============================================================ */

// i18n-Bruecke: aus layout/theme.liquid injiziert (window.themeStrings / window.routes).
// Bewusst ZUWEISUNG statt const-Deklaration: alle Theme-Skripte teilen sich den globalen
// Scope, eine zweite `const T` wuerde einen SyntaxError werfen und die Datei stilllegen.
// Die Fallbacks halten die Datei lauffaehig, falls das Layout die Injection nicht liefert.
window.themeStrings = window.themeStrings || {};
window.routes = window.routes || {};


document.addEventListener('DOMContentLoaded', () => {

  const root = document.querySelector('.cart-page');
  if (!root) return;

  let busy      = false;
  let selfEvent = false;
  // Sequenz-Schutz (Audit R-4): stand zaehlt jede gestartete Mutation und jeden Swap; ein
  // Abgleich (rerenderFromServer nach cart:updated), den einer davon ueberholt, wird verworfen.
  // nachholen: cart:updated kam waehrend einer Mutation — freigeben holt den Abgleich nach.
  let stand     = 0;
  let nachholen = false;

  // Sections jeder Mutation dieser Seite: die eigene plus der Drawer-Vertrag (Audit Warenkorb
  // P-3). Das cart:updated danach traegt sie im detail mit (standMelden), der Drawer
  // nimmt seine Teile daraus statt sie per GET nachzuholen — sonst je Mengenaenderung zwei
  // Abrufe und zwei Server-Renders (POST main-cart + GET cart-drawer,cart-inventory).
  const SECTIONS_SEITE = 'main-cart,' + window.hdkCart.SECTIONS_DRAWER;

  // Beobachter-Sammler (Block 4 des Warenkorb-Audits, F-8): die Observer der Bindungen unten
  // haengen an Knoten, die jeder Swap ersetzt (Liste, Streifen, Dock, Kassen-Knopf). Jede
  // Bindung meldet ihre Observer hier an, neuBinden() meldet alle zentral ab, bevor es neu
  // bindet — statt je einer eigenen Variable mit disconnect-/null-Pflege pro Bindung.
  const beobachter = [];
  const beobachten = (obs) => { if (obs) beobachter.push(obs); return obs; };
  const abmelden = (obs) => {
    obs.disconnect();
    const i = beobachter.indexOf(obs);
    if (i >= 0) beobachter.splice(i, 1);
  };

  // Delegation auf der stabilen .cart-page-Wurzel (ueberlebt den innerHTML-Swap)
  root.addEventListener('click', (e) => {
    // Ausloeser des Mehr-Dialogs (Fueller-Knopf, Cross-Selling-Knopf; Block unten)
    const mehrBtn = e.target.closest('button[data-cart-mehr]');
    if (mehrBtn) { mehrOeffnen(mehrBtn.dataset.cartMehr); return; }
    // Nur der Plus-Knopf (eine Variante); der Pfeil-Link bei mehreren Varianten
    // fuehrt ganz normal auf die Produktseite.
    const fillerBtn = e.target.closest('.cart-filler__add[data-variant-id]');
    if (fillerBtn) { onFillerAdd(fillerBtn); return; }
    const removeLink = e.target.closest('.cart-item__remove');
    if (removeLink) { e.preventDefault(); onRemove(removeLink); }
  });

  // --- Mengenwahl (snippets/cart-line-item.liquid) ---------------------------------
  // Auswahl 1–5 und «6+», ab 6 an derselben Stelle das Feld. Zustaende, Klemmung und
  // Nachsenden leben in EINER Implementierung fuer Drawer und Seite: window.cartMengenwahl
  // (cart-drawer.js, laedt vor dieser Datei). Gebunden an die stabile Wurzel; Mutation ueber
  // sendUpdate unten.
  const mengenwahl = window.cartMengenwahl(root, {
    senden: (updates) => sendUpdate(updates),
    busy: () => busy,
    status: () => document.getElementById('cart-page-status'),
  });

  // Update-Button (nur ohne JS sichtbar) bzw. ein natives Absenden -> via Sections API
  root.addEventListener('submit', (e) => {
    if (!e.target.closest('#cart-page-form')) return;
    e.preventDefault();
    if (busy) return;
    const all = {};
    let changed = false;
    // Getippte Mengen durch dieselbe Regel wie die Mengenwahl (hdk.normalizeQty, Klemmung an
    // data-max mit Zeilen-Meldung) — Helfer aus window.cartMengenwahl.
    root.querySelectorAll('input.cart-item__qty-num:not([disabled])').forEach(inp => {
      const q = mengenwahl.mengeAusFeld(inp);
      mengenwahl.anwenden(inp, q);
      all[inp.dataset.key] = q.value;
      if (q.value !== mengenwahl.serverQty(inp)) changed = true;
    });
    // Kein Request, wenn keine Zeile sich aendert (leeres Feld/Klemmung ohne Effekt):
    // ein Update auf den Ist-Stand kostet einen Roundtrip und wuerde die eben
    // gezeigte Klemm-Meldung mit dem Section-Swap sofort wieder ueberschreiben.
    if (changed) sendUpdate(all);
  });

  // Waehrend eines Requests merkt sich die Mengenwahl das Entfernen vor (Warteschlange je
  // Zeile, cartMengenwahl in cart-drawer.js) statt es still zu verwerfen.
  function onRemove(link) {
    if (link.dataset.key) mengenwahl.absenden(link.dataset.key, 0);
  }

  // Ein Request pro Aktion -> sofort /cart/update.js; die Antwort (Section-HTML)
  // ersetzt den Inhalt. Controls fuer die Dauer des Requests gesperrt (sperren: busy + Dim).
  async function sendUpdate(updates) {
    if (busy || !updates || !Object.keys(updates).length) return;
    sperren();
    // A11Y-4: Fokus + Ansage ueber den geteilten Helfer aus cart-drawer.js (global geladen,
    // vor dieser Datei). Bei mehreren Zeilen (Enter im Formular, nachgesendete Warteschlange)
    // gilt die erste; ihre Klemmung auf den Deckel steht vorne in der Ansage (A-10).
    const a11y = window.cartSwapA11y ? window.cartSwapA11y.vorher(root, Object.keys(updates)[0]) : null;
    if (a11y) a11y.klemmung = mengenwahl.klemmungNehmen(Object.keys(updates)[0]);
    try {
      // hdkCart.update (cart-drawer.js): Misserfolg -> { ok:false, status, art, meldung },
      // Fehlerklassen im Kopf von hdkCart. Wirft nicht.
      const r = await window.hdkCart.update(updates, SECTIONS_SEITE);
      if (!r.ok && r.art !== 'abgelehnt') {
        // Netz weg, Zeitgrenze, 429/5xx (Block 0.5: zuruecksetzen plus Meldung, beide Flaechen
        // gleich): NICHT neu laden — offline landet das in der Browser-Fehlerseite, der
        // Warenkorb waere weg; bei 429 verschaerft sofortiges Neuladen die Drosselung. Wie im
        // Drawer: Mengenwahl jeder betroffenen Zeile auf den
        // Server-Wert, eigene Meldung an der (ersten) Zeile, der Fokus bleibt beim Control.
        console.warn('Cart update failed (' + r.art + '): HTTP ' + r.status + ' ' + r.meldung);
        mengenwahl.verwerfen();
        Object.keys(updates).forEach((key) => mengenwahl.zuruecksetzen(key));
        window.hdkCart.zeilenStoerung(root, Object.keys(updates)[0], window.hdkCart.stoerungsText(r.art));
        return;
      }
      if (!r.ok) {
        // Abgelehnt heisst: die Seite zeigt einen Warenkorb, den der Server so nicht
        // hat (meist fehlender cart-Cookie, 422 «Parameter updates ist ungültig.»,
        // Vorfall 2026-10-09). Neu laden — /cart rendert serverseitig den echten
        // Stand, bei verlorenem Cart den Leer-Zustand. Shopifys Text nur ins Log,
        // nie an die Zeile.
        console.warn('Cart update rejected: HTTP ' + r.status + ' ' + r.meldung);
        mengenwahl.verwerfen();
        window.location.reload();
        return;
      }
      const cart = r.cart;
      swap(cart.sections && cart.sections['main-cart']);
      updateCounter(cart.item_count);
      if (window.cartSwapA11y) {
        // Notfall-Ziel: die Seitenueberschrift (leerer Warenkorb ohne Zeilen)
        const titel = root.querySelector('.cart-page__title');
        if (titel && !titel.hasAttribute('tabindex')) titel.setAttribute('tabindex', '-1');
        window.cartSwapA11y.fokusZurueck(root, a11y, titel);
        window.cartSwapA11y.ansagen(document.getElementById('cart-page-status'), root, a11y, document.getElementById('cart-page-total'));
      }
      // Drawer (oder andere Flaeche) ueber die Aenderung informieren
      standMelden(cart);
    } catch (err) {
      // Nur Programmfehler beim Einbauen der Antwort (update wirft nicht): neu
      // laden, damit die Seite nicht halb getauscht stehen bleibt.
      console.error('Cart update failed:', err);
      mengenwahl.verwerfen();
      window.location.reload();
    } finally {
      freigeben();
    }
  }

  // Ende jedes Requests (Mengen-Update, Fueller-Plus, Kauf im Mehr-Dialog): Sperre und Dim
  // weg, danach eine waehrenddessen gewaehlte Menge nachsenden (window.cartMengenwahl). Vor
  // einem Neuladen verwerfen die Aufrufer sie (die Seite rendert dann ohnehin den Server-Stand).
  function freigeben() {
    busy = false;
    setBusy(false);
    mengenwahl.nachziehen();
    if (nachholen && !busy) {
      nachholen = false;
      rerenderFromServer(true);
    }
  }

  // Beginn jedes Requests (Gegenstueck zu freigeben). stand++: ein laufender Abgleich ist ab
  // jetzt ueberholt (rerenderFromServer, Sequenz-Schutz).
  function sperren() {
    busy = true;
    stand++;
    setBusy(true);
  }

  // --- Warenkorbfueller: ein Klick, ein Add --------------------------------
  // Ueber hdkCart.add wie Drawer, Produktseite und GradedGuard, aber mit der
  // Section dieser Seite ('main-cart', dazu die des Drawers: SECTIONS_SEITE) und eigenem Ende (stattDrawer): auf /cart
  // geht der Drawer NICHT auf, die Seite rendert sich wie nach einer
  // Mengenaenderung neu — Positionen, Fueller, Zusammenfassung und Dock in einem
  // Swap. Server-autoritativ, waehrend des Requests gesperrt (busy + Dim).
  // Fokus und Ansage nach patterns.md «Fokus-Rueckgabe nach einem Section-Swap»:
  // die Karte ist nach dem Add weg (ihr Produkt liegt jetzt im Warenkorb) — wie
  // bei einer entfernten Zeile geht der Fokus aufs Gegenstueck an derselben
  // Position (Plus/Pfeil der Karte, die nachrueckt), sonst auf die neue Position,
  // sonst auf die Seitenueberschrift; nur, wenn er vorher auf dem Knopf lag. Die
  // Ansage nennt Titel, Menge und Total (cart.status_qty, Region ausserhalb des Swaps).
  // Abgelehnt (422) oder Netzfehler: Server-Stand laden (Shopify bucht bei 422 ein,
  // was verfuegbar ist), DANACH cart.filler_error an der Karte — vor dem Swap
  // gesetzt, ersetzte er die Meldung. Kein Rohtext von Shopify an der Karte.
  // Dieselbe Karte steht auch im Cross-Selling unter 900
  // (snippets/cart-filler-karte.liquid): der delegierte Klick oben trifft beide Bloecke,
  // Nachfolger-Fokus und Ersatzplatz der Fehlermeldung bleiben im Block der Karte
  // (`info.block`).
  async function onFillerAdd(btn) {
    if (busy) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    const karte = btn.closest('.cart-filler__card');
    const titelEl = karte && karte.querySelector('.cart-filler__title');
    const block = btn.closest('.cart-cross-sell') ? '.cart-cross-sell' : '.cart-filler--page';
    const info = {
      // Zeilen-Key ist «<variant>:<hash>»; cartSwapA11y.zeile findet die neue
      // Position ueber das Praefix der Varianten-ID.
      key: variantId + ':',
      titel: titelEl ? titelEl.textContent.trim() : '',
      hatteFokus: document.activeElement === btn,
      block,
      position: Array.from(root.querySelectorAll(block + ' .cart-filler__card')).indexOf(karte),
    };
    sperren();
    btn.disabled = true;
    btn.classList.add('cart-filler__add--loading');
    await window.hdkCart.add([{ id: variantId, quantity: 1 }], {
      sections: SECTIONS_SEITE,
      stattDrawer: async (ergebnis) => {
        try {
          // Ohne frischen Stand (Netz weg) bleibt der alte DOM stehen: Knopf freigeben.
          btn.disabled = false;
          btn.classList.remove('cart-filler__add--loading');
          const frisch = await kaufAbschliessen(ergebnis);
          if (frisch === null) return;
          if (!ergebnis.ok) zeigeFuellerFehler(variantId, info.block);
          fokusNachFueller(info, variantId, ergebnis.ok);
          if (ergebnis.ok && window.cartSwapA11y) {
            window.cartSwapA11y.ansagen(document.getElementById('cart-page-status'), root, info, document.getElementById('cart-page-total'));
          }
          if (frisch) seitenStandMelden(ergebnis);
        } finally {
          freigeben();
        }
      }
    });
  }

  // Abschluss eines Adds auf /cart — EIN Weg fuer Fueller-Plus und Kauf im Mehr-Dialog (Block 4
  // des Warenkorb-Audits, F-7). Erfolg: Swap aus der
  // Antwort, ohne Section den Stand holen. Eingebucht, aber kein Stand zu holen: die Seite
  // zeigte einen veralteten Warenkorb (Karte noch da, Total alt) — neu laden wie sendUpdate
  // nach einem abgelehnten Update (dessen Netz-/Serverpfad setzt nur zurueck — hier ist der
  // Artikel aber schon eingebucht). Abgelehnt oder Netz: den Server-Stand holen (Shopify bucht
  // bei 422 ein, was verfuegbar ist). Rueckgabe true = frischer Stand eingesetzt, false = der
  // alte DOM steht noch, null = die Seite laedt neu (der Aufrufer endet dann).
  async function kaufAbschliessen(ergebnis) {
    if (!ergebnis.ok) return rerenderFromServer();
    const html = ergebnis.daten && ergebnis.daten.sections && ergebnis.daten.sections['main-cart'];
    const frisch = html ? swap(html) : await rerenderFromServer();
    if (frisch) return true;
    mengenwahl.verwerfen();
    window.location.reload();
    return null;
  }

  // Zaehler und andere Flaechen (cart:updated -> stiller Abgleich im Drawer) auf den Stand der
  // Seite; add.js liefert keinen Cart, darum Anzahl und Total aus dem frischen Markup. War der
  // Add erfolgreich, reicht das Event die mitbestellten Drawer-Sections weiter (P-3); sonst kam
  // der Stand per rerenderFromServer (nur main-cart) und der Drawer holt sich seinen selbst.
  function seitenStandMelden(ergebnis) {
    const stand = standDerSeite();
    const sections = ergebnis && ergebnis.ok && ergebnis.daten && ergebnis.daten.sections;
    if (sections) stand.sections = sections;
    updateCounter(stand.item_count);
    standMelden(stand);
  }

  // cart:updated an die anderen Flaechen; selfEvent -> der eigene Listener (Quer-Sync unten)
  // ignoriert die eigene Mutation (kein Selbst-Trigger, kein Loop).
  function standMelden(detail) {
    selfEvent = true;
    document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
    selfEvent = false;
  }

  // Meldung nach einem abgelehnten Add an die Karte (nach dem Neuladen gesucht).
  // Ist die Karte weg (Artikel inzwischen nicht mehr kaufbar), steht die Meldung
  // ueber dem Streifen ihres Blocks (Fueller oder Cross-Selling); ohne den Block sagt
  // die Status-Region sie an.
  function zeigeFuellerFehler(variantId, blockSel) {
    const text = window.themeStrings.fillerError || '';
    if (!text) return;
    // Ohne frischen Stand (Netz weg) steht noch die Meldung eines frueheren Versuchs.
    root.querySelectorAll('.cart-filler__error').forEach((alt) => alt.remove());
    const meldung = document.createElement('p');
    meldung.className = 'cart-filler__error';
    meldung.setAttribute('role', 'alert');
    meldung.textContent = text;
    const knopf = root.querySelector('.cart-filler__add[data-variant-id="' + variantId + '"]');
    const karte = knopf && knopf.closest('.cart-filler__card');
    const block = root.querySelector(blockSel || '.cart-filler--page');
    if (karte) {
      karte.appendChild(meldung);
    } else if (block) {
      block.insertBefore(meldung, block.querySelector('.cart-filler__viewport'));
    } else {
      const region = document.getElementById('cart-page-status');
      if (region) region.textContent = text;
    }
  }

  // Fokus nach einem Fueller-Add (Ersatzkette im Kommentar zu onFillerAdd).
  // Abgelehnt: dieselbe Karte, falls es sie nach dem Neuladen noch gibt.
  function fokusNachFueller(info, variantId, ok) {
    if (!info.hatteFokus) return;
    let ziel = null;
    if (!ok) ziel = root.querySelector('.cart-filler__add[data-variant-id="' + variantId + '"]');
    if (!ziel) {
      const karten = root.querySelectorAll((info.block || '.cart-filler--page') + ' .cart-filler__card');
      const nachfolger = karten.length ? karten[Math.min(Math.max(info.position, 0), karten.length - 1)] : null;
      ziel = nachfolger && nachfolger.querySelector('.cart-filler__add:not([disabled])');
    }
    if (!ziel && window.cartSwapA11y) {
      const zeile = window.cartSwapA11y.zeile(root, info.key);
      ziel = zeile && zeile.querySelector('.cart-item__title');
    }
    if (!ziel) {
      ziel = root.querySelector('.cart-page__title');
      if (ziel && !ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
    }
    if (ziel) ziel.focus({ preventScroll: true });
  }

  // Anzahl und Total des gerenderten Server-Stands (data-* an .cart-page__inner,
  // main-cart.liquid) — gleiche Form wie das cart:updated-Detail des Drawers.
  function standDerSeite() {
    const inner = root.querySelector('.cart-page__inner');
    return {
      item_count: parseInt((inner && inner.dataset.cartCount) || '0', 10),
      total_price: parseInt((inner && inner.dataset.cartTotal) || '0', 10),
    };
  }

  // Dim-/Sperr-Signal waehrend eines Requests. swap() ersetzt root.innerHTML;
  // die Klasse sitzt auf root selbst -> wird hier wieder entfernt.
  function setBusy(on) {
    root.classList.toggle('cart-page--busy', on);
  }

  // Inhalt der .cart-page aus dem zurueckgegebenen Section-HTML ersetzen
  // (deckt Items, Fueller, Cross-Selling, Summary, Kassen-Dock und den Leer-Zustand
  // in einem ab). Dock, beobachteter Kassen-Knopf, Fueller-, Cross-Selling- und
  // Bewertungs-Streifen sowie die Positionsliste (Rabatt-Kurzform) sind danach neue
  // Knoten -> neu binden (neuBinden, unten). Rueckgabe true = Inhalt
  // ersetzt. Der Mehr-Dialog steht ausserhalb von .cart-page und bleibt stehen.
  // Vor dem Einhaengen, auf dem geparsten Dokument: die Ausloeser des Mehr-Dialogs
  // freischalten (sonst blitzte der Link auf). Vertagte Bilder (data-defer-src) und
  // Judge.me-Badges gibt es auf /cart keine: das Cross-Selling-Raster laedt nativ
  // lazy (Audit Warenkorb P-12), seine Karten tragen die Bewertungszeile des Themes
  // (eigene_sterne, P-2).
  function swap(html) {
    if (!html) return false;
    const doc   = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.cart-page');
    if (!fresh) return false;
    window.cartMehr.ausloeser(fresh);
    stand++;
    root.innerHTML = fresh.innerHTML;
    neuBinden();
    return true;
  }

  // EINE Liste der Bindungen fuer den Seitenaufbau UND jeden Swap (Block 4 des Warenkorb-
  // Audits, F-8). Reihenfolge = die des Swaps: die Lagerzeilen (verfuegbarkeit) vor der
  // Kurzform-Messung (rabattBinden), die uebrigen Bindungen sind voneinander unabhaengig.
  // Vorher alle Observer der alten Knoten ab (Beobachter-Sammler oben).
  function neuBinden() {
    beobachter.splice(0).forEach((obs) => obs.disconnect());
    bindDock();
    fuellerBinden();
    bindCrossSell();
    bindReviews();
    verfuegbarkeit();
    rabattBinden();
    umbruchPruefen();
  }

  // --- Einzeilige Saetze der Zusammenfassung bei grosser Mindestschrift (Audit R-12) -----------
  // Versand-Satz (cqi-Groesse) und Rabattcode-Hinweis stehen per nowrap auf EINER Zeile
  // (cart-page.css); hebt eine Browser-Mindestschrift (z. B. 20 px) die Groesse an, laufen die
  // Saetze ueber die Karte und die Seite scrollt quer. Ragt einer ueber
  // die Innenkante der Zusammenfassung, darf er umbrechen (darf-umbrechen). Erst die Klasse weg,
  // dann messen (Range ueber den Text) — so faellt er zurueck, sobald er wieder passt. Beim Laden,
  // nach jedem Swap (neuBinden), bei Fensteraenderung und wenn die Schriften geladen sind.
  function umbruchPruefen() {
    root.querySelectorAll('.shipping-progress--summary .shipping-progress__text, .cart-page__summary-note').forEach((el) => {
      const kasten = el.closest('.cart-page__summary-inner');
      if (!kasten) return;
      el.classList.remove('darf-umbrechen');
      const k = kasten.getBoundingClientRect();
      const st = getComputedStyle(kasten);
      const text = document.createRange();
      text.selectNodeContents(el);
      const t = text.getBoundingClientRect();
      if (t.right > k.right - parseFloat(st.paddingRight) + 1 || t.left < k.left + parseFloat(st.paddingLeft) - 1) el.classList.add('darf-umbrechen');
    });
  }
  window.addEventListener('resize', umbruchPruefen, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(umbruchPruefen);

  // --- Verfuegbarkeit: Lagerzeile je Position, Lieferzeile unter dem Titel ---------------
  // Lagerzeile (snippets/cart-line-item.liquid, .cart-item__avail, sichtbar ab 900): EINE
  // Zeile, Punkt + Text wie die Lagerzeile der Produktkarte. Lagertext = window.hdk.lagerText
  // (Schwellen 10/6) — keine eigene Schwelle hier —, aber mit dem kurzen Wortlaut der
  // Warenkorb-Locales (themeStrings cartStock*, cart.stock_*): «Über 10 an Lager» statt
  // «Mehr als 10 Stück an Lager», «Nachbestellt» statt «Beim Lieferanten nachbestellt» —
  // die Textspalte ist ab 900 bis auf 143 px schmal (Fenster 900 mit Scrollleiste, Raster in
  // cart-page.css). Die Schluessel von hdk.lagerText bildet LAGER_KURZ auf die Warenkorb-
  // Strings ab; «Verfügbar»/«Nicht verfügbar» sind die der Produktseite.
  // Datenquelle: die data-Attribute des Blocks (Server-Stand der Zeile, kommen mit jedem
  // Section-Swap frisch), nicht window.variantInventory — das gehoert zum Drawer-Vertrag
  // (cart-inventory) und pflegt der Drawer.
  // Zustaende in der Reihenfolge der Produktseite (product-page.js, updateQtyUI):
  //   nachbestellt (Eingang, kein Bestand) -> amber «Nachbestellt»
  //   nicht verfuegbar                     -> rot «Nicht verfügbar»
  //   verfuegbar                           -> gruen (Haken), Lagertext bei gezaehltem
  //                                           Bestand, sonst «Verfügbar» (ungetrackt/
  //                                           Ueberverkauf, Regel 3 der Produktkarte)
  // Lieferzeile (sections/main-cart.liquid, #cart-page-delivery, alle Breiten): EIN Termin
  // fuer den ganzen Warenkorb, keine Lieferzeile je Position. Nur wenn JEDE Position gruen
  // ist; eine Vorbestellung (Zeile ohne Block) oder
  // eine nachbestellte bzw. nicht verfuegbare Position laesst sie leer, die Lagerzeilen
  // zeigen dann, woran es liegt. Der Termin haengt an der Uhrzeit (Bestellkante 15:00
  // Zuerich) und wird darum nie in Liquid gerendert (CDN-Cache, docs/patterns.md
  // «Zeitabhaengige Anzeige»); Regel = window.hdk.lieferAussage (dieselbe wie Produktseite
  // und Karten-Tooltip), Wortlaut «Übermorgen, 23.10.2026» = window.hdk.lieferDatumText.
  // Neu gerechnet beim Laden, nach jedem Swap, im 30-s-Raster und bei Tab-Rueckkehr (die
  // Kante kann kippen, waehrend der Tab schlaeft) — Muster updateDeliveryEstimate.
  // Ohne Punkt davor, das Zeitwort traegt die Gold-Hairline. innerHTML-Quelle ist eigenes
  // Markup: Punkt (nur Lagerzeile) +
  // Locale-Texte (Zeitwoerter ohne _html, vom t-Filter escaped) + Wochentag aus Intl und
  // Ziffern; geschrieben wird nur bei Aenderung.
  const punktMarkup = (farbe) => '<span class="stock-dot stock-dot--' + farbe + '"></span>';
  // Text in EINEM Span: die Lagerzeile ist display: flex — ein nackter Textknoten neben
  // dem Punkt wuerde ein eigenes Flex-Item, das Leerzeichen davor fiele weg.
  const textMarkup = (t) => '<span>' + t + '</span>';
  const LAGER_KURZ = { stockMoreThan: 'cartStockMoreThan', stockCount: 'cartStockCount', stockCountFew: 'cartStockCountFew' };

  function lagerZeile(d, str) {
    const bestand = parseInt(d.stock, 10);
    const gezaehlt = d.tracked === 'true' && bestand > 0;
    if (d.incoming === 'true' && !gezaehlt) return { lieferbar: false, html: punktMarkup('amber') + textMarkup(str.cartStockIncoming) };
    if (d.available !== 'true') return { lieferbar: false, html: punktMarkup('red') + textMarkup(str.unavailable) };
    let lager = str.available;
    // cartStockMoreThan traegt die Schwelle schon (count: 10), die beiden anderen __N__.
    if (gezaehlt) lager = str[LAGER_KURZ[window.hdk.lagerText(bestand)]].replace('__N__', bestand);
    return { lieferbar: true, html: punktMarkup('green') + textMarkup(lager) };
  }

  function verfuegbarkeit() {
    const str = window.themeStrings;
    if (!window.hdk || !str.cartStockMoreThan) return;
    let alleLieferbar = true;
    root.querySelectorAll('#cart-page-items .cart-item').forEach((zeile) => {
      const block = zeile.querySelector('.cart-item__avail');
      if (!block) { alleLieferbar = false; return; }
      const z = lagerZeile(block.dataset, str);
      if (!z.lieferbar) alleLieferbar = false;
      const el = block.querySelector('.cart-item__stock');
      if (el && el.innerHTML !== z.html) el.innerHTML = z.html;
    });
    lieferzeile(alleLieferbar, str);
  }

  function lieferzeile(alleLieferbar, str) {
    const el = root.querySelector('#cart-page-delivery');
    if (!el) return;
    let html = '';
    if (alleLieferbar && str.deliveryEstimate && str.deliveryEstTomorrow) {
      const lang = document.documentElement.lang || 'de';
      const wann = window.hdk.lieferDatumText(window.hdk.lieferAussage(new Date(), lang, str), lang, str);
      // Ohne Punkt; Zeitwort + Datum (<strong>) traegt die Gold-Hairline (theme.css).
      if (wann) html = textMarkup(str.deliveryEstimate.replace('__WHEN__', wann));
    }
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  setInterval(verfuegbarkeit, 30000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) verfuegbarkeit();
  });

  // --- Rabattzeile: Kurzform «Sale» als Notnagel (alle Breiten) -----------------------
  // Wuerde die Zeile zu lang, kuerzt sie den Rabattnamen auf «Sale» («Ordnerseiten Sale» ->
  // «Sale»). Ab 900 steht die Rabattzeile in jedem Band neben dem Text unter der Staffel-Leiste,
  // in einer Huelle von 170 bis 200 px; unter 900 traegt sie dieselbe Pille rechtsbuendig in der
  // Info-Spalte (bei 320 px 186 px breit, cart-drawer.css). Die Messung selbst ist EINE
  // Funktion fuer Drawer und Seite: window.cartRabattKurzform in cart-drawer.js (Kriterium,
  // Ablauf und Herleitung dort). Keine Breiten-Weiche: die Pille steht auf allen Breiten.
  // Hier bleibt die Bindung an die Liste der Seite.
  // Aufrufe: beim Laden und nach jedem Swap (rabattBinden), bei Breitenaenderung der Liste und
  // einmal, wenn die Schriften geladen sind (die Breite der Pille haengt an Inter). Der
  // Beobachter (window.cartRabattKurzform.beobachten in cart-drawer.js, geteilt mit dem
  // Drawer: nur Breite, Messung im naechsten Frame — Begruendung dort) haengt an
  // #cart-page-items (deren Breite bestimmt die Baender, Container cart-items, und unter 900
  // die Info-Spalte) und ist nach jedem Swap neu gebunden — der alte Knoten ist weg.
  function rabattKurzform() {
    if (window.cartRabattKurzform) window.cartRabattKurzform(root.querySelector('#cart-page-items'));
  }
  function rabattBinden() {
    const liste = root.querySelector('#cart-page-items');
    if (liste && window.cartRabattKurzform) beobachten(window.cartRabattKurzform.beobachten(liste));
    rabattKurzform();
  }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(rabattKurzform);

  // --- Cross-Selling (snippets/cart-cross-sell.liquid) ---------------------
  // Zwei Markups (cart-page.css): unter 900 px der Streifen des
  // Warenkorbfuellers — Fades bindet fuellerBinden (unten, alle .cart-filler__viewport), Plus
  // kauft ueber onFillerAdd, Maus-Drag ueber die delegierte hdkDragScroll-Bindung —, ab 900
  // das Produktkarten-Raster. Dessen Mechanik = brand-strip.js (window.initBrandStrip:
  // Maus-Drag, Overflow-Klassen und — ueber den data-strip-dots-Container — die Positions-
  // Punkte), dieselbe wie auf der Produktseite; ohne Ueberlauf (Raster) setzt sie nichts.
  // Sie laeuft nur auf dem gerenderten Raster: unter 900 ist es display: none, und ein
  // Drehen des Tablets ueber 900 hinweg holt die Bindung nach (ResizeObserver: ein
  // ausgeblendetes Element meldet sich, sobald es eine Box bekommt). Das Raster ist nach
  // jedem Swap ein neuer Knoten: beim Laden und nach jedem Swap neu binden; die Listener des
  // alten haengen an dessen Knoten bzw. raeumen sich ab (brand-strip.js, isConnected).
  // Keine Badge-Lokalisierung: die Karten tragen die Bewertungszeile des Themes
  // (eigene_sterne, Audit P-2). Die Bilder laden nativ lazy (P-12); das versteckte
  // Raster unter 900 hat keine Box und laedt nichts.
  function bindCrossSell() {
    const strip = root.querySelector('.cart-cross-sell__strip');
    if (!strip) return;
    if (typeof window.initBrandStrip !== 'function') return;
    let ro = null;
    const binden = () => {
      if (!strip.isConnected || !strip.getClientRects().length) return false;
      window.initBrandStrip(strip);
      if (ro) { abmelden(ro); ro = null; }
      return true;
    };
    if (binden() || !('ResizeObserver' in window)) return;
    ro = beobachten(new ResizeObserver(binden));
    ro.observe(strip);
  }

  // --- Bewertungs-Karussell der Zusammenfassung (snippets/cart-reviews.liquid) -------
  // Eine Kachel im Bild, Pfeile und Punkte in einer Zeile darunter. Mechanik wie beim
  // Cross-Selling: window.initBrandStrip (brand-strip.js) bindet Pfeile (data-brand-prev/
  // -next, Schritt = eine Kachel ueber data-scroll-step="item"), Maus-Drag und — ueber
  // den data-strip-dots-Container — die Punkte. Die Zusammenfassung ist nach jedem Swap
  // ein neuer Knoten: beim Laden und nach jedem Swap neu binden (kein data-brand-strip am
  // Root, der Autoload liefe sonst doppelt). «Mehr lesen» der Kacheln:
  // window.initReviewCards misst die frischen Kacheln; der Klick ist am Dokument
  // delegiert und braucht keine Bindung.
  function bindReviews() {
    const karussell = root.querySelector('.cart-reviews__carousel');
    if (!karussell) return;
    if (typeof window.initBrandStrip === 'function') window.initBrandStrip(karussell);
    if (typeof window.initReviewCards === 'function') window.initReviewCards(karussell);
  }

  // --- Fueller-Streifen (< 900): Kanten-Fades und Maus-Drag ------------------
  // Fades nach dem Muster des Marken-Strips (brand-strip.js laedt auf /cart, bindet aber
  // nur Streifen mit data-brand-viewport — Cross-Selling-Raster und Bewertungen; der
  // Fueller-Streifen traegt keins): is-overflow-start/-end am nicht scrollenden Viewport,
  // nur wenn in der Richtung Karten verborgen sind. Es gibt zwei solche
  // Streifen — Fueller-Block und Cross-Selling unter 900 —, gebunden wird jeder
  // .cart-filler__viewport der Seite. Die Streifen sind nach jedem Swap neue
  // Knoten — der Scroll-Listener haengt am Streifen und geht mit ihm; der
  // ResizeObserver (Drehen, Fenster) wird wie beim Dock neu gebunden. Ab 900 ist
  // der Fueller ein Raster ohne Ueberlauf und der Cross-Selling-Streifen aus
  // (Breite 0): die Klassen bleiben dann aus.
  function fuellerBinden() {
    const planer = new Map();
    root.querySelectorAll('.cart-filler__viewport').forEach((viewport) => {
      const streifen = viewport.querySelector('.cart-filler__strip');
      if (!streifen) return;
      let raf = null;
      const messen = () => {
        raf = null;
        const max = streifen.scrollWidth - streifen.clientWidth;
        const ueberlauf = max > 1;
        viewport.classList.toggle('is-overflow-start', ueberlauf && streifen.scrollLeft > 1);
        viewport.classList.toggle('is-overflow-end', ueberlauf && streifen.scrollLeft < max - 1);
      };
      const planen = () => { if (!raf) raf = window.requestAnimationFrame(messen); };
      streifen.addEventListener('scroll', planen, { passive: true });
      planer.set(streifen, planen);
      messen();
    });
    if (planer.size && 'ResizeObserver' in window) {
      const ro = beobachten(new ResizeObserver((eintraege) => {
        eintraege.forEach((eintrag) => { const planen = planer.get(eintrag.target); if (planen) planen(); });
      }));
      planer.forEach((planen, streifen) => ro.observe(streifen));
    }
  }
  // Maus-Drag: EINE Mechanik (window.hdkDragScroll, theme.js), delegiert an der
  // stabilen Wurzel, weil der Streifen bei jedem Swap ersetzt wird (wie der
  // Drawer am Drawer-Root). Nur linke Taste, nur bei echtem Ueberlauf (ab 900
  // nichts zu ziehen); Touch scrollt nativ mit Snap.
  if (window.hdkDragScroll) window.hdkDragScroll(root, { ziel: '.cart-filler__strip', nurLinks: true, nurBeiUeberlauf: true });
  // Tastaturfokus: fokussierte Karte ins Bild (window.cartStreifenFokus in cart-drawer.js, Audit D-2).
  if (window.cartStreifenFokus) window.cartStreifenFokus(root);

  // --- Mehr-Dialog (#cart-mehr, snippets/cart-mehr-dialog.liquid) -----------------
  // Weitere Warenkorbfueller bzw. alle ergaenzenden Produkte zeigen, ohne die Warenkorbseite
  // zu verlassen. Auch der Drawer oeffnet denselben Dialog — Dialog, Ausschluss, Knopf-Zustaende, Escape und
  // Fokus leben darum in EINER Implementierung: window.cartMehr in cart-drawer.js (Begruendung
  // dort), die Shell in snippets/cart-mehr-dialog.liquid. Hier bleibt die
  // Flaeche der Seite: die Wurzel (Fueller- und Cross-Selling-Block mit data-produkt-ids, die
  // Ausloeser), der Kauf und der Fokus-Ersatz (die h1).
  // Kauf: hdkCart.add mit SECTIONS_SEITE + stattDrawer wie der Fueller-Plus — die Seite
  // dahinter rendert sich per swap() neu, der Dialog bleibt offen. Sperre und Nachsenden wie
  // bei jeder Mutation (busy, freigeben); das Ende (Swap, Neuladen, Server-Stand) ist dasselbe
  // wie beim Fueller-Plus (kaufAbschliessen).
  window.cartMehr.ausloeser(root);

  function mehrOeffnen(art) {
    window.cartMehr.oeffnen(art, {
      wurzel: root,
      kaufen: mehrKaufen,
      ersatz: () => {
        const titel = root.querySelector('.cart-page__title');
        if (titel && !titel.hasAttribute('tabindex')) titel.setAttribute('tabindex', '-1');
        return titel;
      },
      statusId: 'cart-page-status',
    });
  }

  async function mehrKaufen(variantId) {
    let aus = null;
    sperren();
    await window.hdkCart.add([{ id: variantId, quantity: 1 }], {
      sections: SECTIONS_SEITE,
      stattDrawer: async (ergebnis) => {
        try {
          const frisch = await kaufAbschliessen(ergebnis);
          if (frisch === null) { aus = { neuGeladen: true }; return; }
          if (frisch) seitenStandMelden(ergebnis);
          aus ={ ok: ergebnis.ok, meldung: ergebnis.meldung, container: root, totalEl: document.getElementById('cart-page-total') };
        } finally {
          freigeben();
        }
      }
    });
    return aus;
  }

  // --- Kassen-Dock (mobil < 900 px, sections/main-cart.liquid) -------------
  // Muster Sticky-ATC (product-page.js): IntersectionObserver statt Scroll-
  // Listener, gemessene Hoehe als Body-Polster (--cart-dock-h, body.has-cart-dock).
  // Die Variable steht am <html>, nicht am <body> (Audit A-2): dort
  // braucht sie auch scroll-padding-bottom (cart-page.css), damit ein per Tab
  // fokussiertes Element nicht unter dem Dock landet; der Body erbt sie fuers Polster.
  // Zwei bewusste Unterschiede:
  //  - Sichtbar, solange der Kassen-Knopf der Zusammenfassung NICHT im Bild ist —
  //    davor (Positionen) wie dahinter (Footer); die Kasse ist so immer erreichbar. Umschalten
  //    mit Hysterese gegen die ein- und ausklappende Adressleiste (Kommentar in bindDock).
  //  - Das Polster bleibt, solange es ein Dock gibt, auch wenn es weggefahren ist:
  //    ein Polster, das mit dem Dock kaeme und ginge, verschoebe am Seitenende die
  //    Scrollposition und damit den beobachteten Knopf (Rueckkopplung).
  // dockGezeigt ueberlebt den Section-Swap: das neue Dock uebernimmt den Zustand
  // ohne Einfahr-Animation (Klasse VOR dem ersten Messen gesetzt), statt bei jeder
  // Mengenaenderung neu einzufahren. Ab 900 px blendet CSS das Dock aus; die
  // gemessene Hoehe ist dort 0, das Polster nimmt das CSS ohnehin zurueck.
  let dockGezeigt = false;
  let dockGebunden = false;

  function bindDock() {
    const dock = root.querySelector('.cart-dock');
    const knopf = root.querySelector('.cart-page__checkout-btn');
    // Leerer Warenkorb (kein Dock im Markup) oder Browser ohne Observer: kein Dock,
    // kein Polster. Das Dock steht serverseitig `hidden` und bleibt es dann.
    if (!dock || !knopf || !('IntersectionObserver' in window) || !('ResizeObserver' in window)) {
      dockGezeigt = false;
      document.body.classList.remove('has-cart-dock');
      document.documentElement.style.removeProperty('--cart-dock-h');
      return;
    }
    dock.hidden = false;
    dock.classList.toggle('is-shown', dockGezeigt);
    document.body.classList.add('has-cart-dock');
    beobachten(new ResizeObserver(() => {
      document.documentElement.style.setProperty('--cart-dock-h', dock.offsetHeight + 'px');
    })).observe(dock);
    // Umschalten mit Hysterese: mit EINER Schwelle («Knopf beruehrt das Fenster») fuehre das
    // Dock nahe dem Kassen-Knopf bei jeder Aenderung der Fensterhoehe ein und aus (es zittert) —
    // genau das tun mobile Browser beim Scrollen, wenn die Adressleiste ein- und ausklappt.
    // Darum zwei Schwellen:
    // weg, sobald der Kassen-Knopf GANZ im Fenster steht; wieder da, erst wenn er eine
    // Dock-Hoehe unter dem Fensterrand (oder ueber dem Fenster) liegt. Dazwischen bleibt der
    // Zustand — das Band ist breiter als der Sprung der Adressleiste. Beim ersten Binden ohne
    // Vorzustand gilt «Knopf nicht ganz sichtbar = Dock da»; nach einem Swap uebernimmt das neue
    // Dock den Zustand (dockGezeigt).
    const setzen = (an) => { dockGezeigt = an; dock.classList.toggle('is-shown', an); };
    let erstesMal = !dockGebunden;
    dockGebunden = true;
    beobachten(new IntersectionObserver((entries) => {
      const ganz = entries[entries.length - 1].intersectionRatio >= 0.99;
      if (ganz) setzen(false);
      else if (erstesMal) setzen(true);
      erstesMal = false;
    }, { threshold: [0, 0.99] })).observe(knopf);
    const band = Math.max(dock.offsetHeight, 96);
    beobachten(new IntersectionObserver((entries) => {
      if (!entries[entries.length - 1].isIntersecting) setzen(true);
    }, { rootMargin: '0px 0px ' + band + 'px 0px', threshold: 0 })).observe(knopf);
  }

  // Erste Bindung beim Seitenaufbau — dieselbe Liste wie nach jedem Swap (neuBinden, oben).
  neuBinden();

  function updateCounter(count) {
    // Name des Header-Warenkorbs mitziehen (Audit A-4; Helfer im Drawer, cart-drawer.js)
    if (window.CartDrawer && window.CartDrawer.zaehlerBenennen) window.CartDrawer.zaehlerBenennen(count);
    const counter = document.querySelector('.header__cart-count');
    if (!counter) return;
    if (count > 0) counter.textContent = count;
    else counter.remove();
  }

  // Quer-Sync: aendert eine andere Flaeche (Drawer) den Cart, feuert sie cart:updated -> /cart frisch rendern.
  // selfEvent -> eigene Mutation wird ignoriert (kein Selbst-Trigger / kein Loop). Laeuft gerade
  // eine eigene Mutation, holt freigeben den Abgleich danach nach (Audit R-4: ein GET waehrend
  // eines zurueckgehaltenen POST kann spaeter ankommen und die neue Menge auf den alten Stand setzen).
  document.addEventListener('cart:updated', () => {
    if (selfEvent) return;
    if (busy) { nachholen = true; return; }
    rerenderFromServer(true);
  });

  // bfcache-Restore (Zurueck-Taste, Tab aus dem Verlauf): der Browser zeigt den
  // eingefrorenen Stand von damals — inzwischen kann der Warenkorb bestellt oder
  // geleert sein (Vorfall 2026-10-09). Neu laden: /cart rendert den echten Stand
  // serverseitig, Formular eingeschlossen; der Drawer laesst /cart dafuer aus.
  // Bewusst KEIN Reload bei blosser Sichtbarkeit (Tab-Wechsel): ein Klick auf eine
  // veraltete Zeile faengt der 422-Pfad in sendUpdate ab, und aendert der
  // Hintergrund-Abgleich des Drawers den Stand, rendert cart:updated /cart neu.
  window.addEventListener('pageshow', (e) => { if (e.persisted) window.location.reload(); });

  // Rueckgabe true = frischer Stand eingesetzt (der Fueller-Fehlerpfad meldet nur dann weiter).
  // verwerfbar (Abgleich nach cart:updated): hat waehrend des Abrufs eine Mutation begonnen oder
  // ein Swap stattgefunden (stand), ist die Antwort ueberholt — nicht anwenden (Audit R-4).
  async function rerenderFromServer(verwerfbar) {
    const vorher = stand;
    try {
      const res  = await fetch(window.routes.root + '?sections=main-cart');
      const data = await res.json();
      if (verwerfbar && (stand !== vorher || busy)) return false;
      return swap(data['main-cart']);
    } catch (e) { /* best effort */ return false; }
  }

});
